import { sanitizeCsvCell } from "@SeemplicityDev/shared";

export interface TableActions {
  allowActions?: boolean;
  csvNamePrefix?: string;
}

/**
 * Parses a <table> DOM element into a 2D array for react-csv's CSVLink.
 * Header row is derived from <thead th>, data rows from <tbody td>.
 */
export const buildCsvData = (tableEl: HTMLTableElement): string[][] => {
  const headers = [...tableEl.querySelectorAll("thead th")].map((th) =>
    sanitizeCsvCell(th.textContent?.trim() ?? "")
  );
  const rows = [...tableEl.querySelectorAll("tbody tr")].map((tr) =>
    [...tr.querySelectorAll("td")].map((td) =>
      sanitizeCsvCell(td.textContent?.trim() ?? "")
    )
  );
  return !!headers.length ? [headers, ...rows] : rows;
};

/**
 * Derives a table name from the closest preceding heading sibling in the DOM.
 * Returns null if no heading is found — callers apply their own fallback.
 */
export const getTableName = (tableEl: HTMLTableElement): string | null => {
  const outer = tableEl.closest(".markdown-table-outer");
  let el = outer?.previousElementSibling ?? null;
  while (el) {
    if (/^H[1-6]$/.test(el.tagName)) {
      const name = el.textContent?.trim().replace(/\s+/g, "_");
      if (name) {
        return name;
      }
    }
    el = el.previousElementSibling;
  }
  return null;
};
